import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "c-bg--gray--pc c-common-footer-fixed"
}
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = { class: "p-the-page-h12" }
const _hoisted_5 = { class: "p-the-page-h12__header" }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  key: 0,
  class: "p-the-page-h12__body"
}
const _hoisted_8 = {
  key: 1,
  class: "p-the-page-h12__body"
}
const _hoisted_9 = { class: "p-the-page-h12__list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "p-the-page-h12__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheBreadcrumb = _resolveComponent("TheBreadcrumb")!
  const _component_CommonHeading = _resolveComponent("CommonHeading")!
  const _component_ExpirationItemPanel = _resolveComponent("ExpirationItemPanel")!
  const _component_PageNavi = _resolveComponent("PageNavi")!
  const _component_FloatingGivePointButton = _resolveComponent("FloatingGivePointButton")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _directive_touch = _resolveDirective("touch")!

  return (_ctx.isApiResponse)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_TheHeader, { ref: "theHeader" }, null, 512),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_TheBreadcrumb),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_CommonHeading, null, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createTextVNode(" 有効期限切れのポイント ", -1)
                  ])),
                  _: 1,
                  __: [0]
                }),
                _withDirectives((_openBlock(), _createElementBlock("a", {
                  href: _ctx.link,
                  class: "p-the-page-h12__header__link"
                }, _cache[1] || (_cache[1] = [
                  _createElementVNode("span", { class: "p-the-page-h12__header__link__text" }, " ポイント有効期限一覧はこちら ", -1)
                ]), 8, _hoisted_6)), [
                  [_directive_touch, void 0, "tap"]
                ])
              ]),
              (_ctx.expirationCnt == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[2] || (_cache[2] = [
                    _createElementVNode("p", null, "有効期限切れのポイントはありません。", -1)
                  ])))
                : _createCommentVNode("", true),
              (_ctx.expirationCnt != 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("ul", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expirationData, ({
                  expiry_date,
                  transaction_details,
                  points,
                  transaction_type,
                  history_id
                }, key) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: key,
                          class: "p-the-page-h12__list__item",
                          onClick: ($event: any) => (_ctx.expiredDetails(history_id))
                        }, [
                          (transaction_type === 50)
                            ? (_openBlock(), _createBlock(_component_ExpirationItemPanel, {
                                key: 0,
                                date: expiry_date,
                                detail: _ctx.detail(transaction_details),
                                point: points,
                                status: '受贈'
                              }, null, 8, ["date", "detail", "point"]))
                            : (_openBlock(), _createBlock(_component_ExpirationItemPanel, {
                                key: 1,
                                date: expiry_date,
                                detail: _ctx.detail(transaction_details),
                                point: points,
                                status: '付与',
                                label: _ctx.getLabel(transaction_details)
                              }, null, 8, ["date", "detail", "point", "label"]))
                        ], 8, _hoisted_10))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                (_ctx.pageNavi.maxPage > 1)
                  ? (_openBlock(), _createBlock(_component_PageNavi, {
                      key: 0,
                      "current-page": _ctx.pageNavi.currentPage,
                      "next-page-url": _ctx.pageNavi.nextPageUrl,
                      "prev-page-url": _ctx.pageNavi.prevPageUrl,
                      "max-page": _ctx.pageNavi.maxPage,
                      "base-url": _ctx.pageNavi.baseUrl
                    }, null, 8, ["current-page", "next-page-url", "prev-page-url", "max-page", "base-url"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createVNode(_component_FloatingGivePointButton),
        _createVNode(_component_TheFooter)
      ]))
    : _createCommentVNode("", true)
}